import React, { useState } from 'react';
import { Box, Typography, Grid, Card, CardContent, CardMedia, Button, Container, Paper, Divider, IconButton, Dialog, DialogContent } from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

// Styled components
const GalleryCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  transition: 'transform 0.3s ease-in-out',
  cursor: 'pointer',
  '&:hover': {
    transform: 'scale(1.03)',
    boxShadow: theme.shadows[8],
  },
}));

const ContactCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  transition: 'transform 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-10px)',
    boxShadow: theme.shadows[8],
  },
}));

const ContactIcon = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  color: theme.palette.primary.contrastText,
  borderRadius: '50%',
  width: 60,
  height: 60,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
  '& svg': {
    fontSize: 30,
  },
}));

const LogoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: theme.spacing(4),
  '& img': {
    maxHeight: 80,
    maxWidth: '100%',
  },
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  transition: 'transform 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-5px)',
  },
}));

const ContactInfo = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
  '& svg': {
    marginRight: theme.spacing(1),
    color: theme.palette.primary.main,
  },
}));

const GalleryImage = styled('img')({
  width: '100%',
  height: '200px',
  objectFit: 'cover',
  borderRadius: '8px',
  marginBottom: '16px',
});

// Gallery images
const galleryImages = [
  '/images/shivay/gallery/gallery1.jpg',
  '/images/shivay/gallery/gallery2.jpg',
  '/images/shivay/gallery/gallery3.jpg',
  '/images/shivay/gallery/gallery4.jpg',
  '/images/shivay/gallery/gallery5.jpg',
  '/images/shivay/gallery/gallery6.jpg',
];

// Contact information
const contactInfo = {
  phone: '+91 70146 54564',
  whatsapp: '+91 70146 54564',
  email: 'shivaystonex13@gmail.com',
  address: 'Shivay Stonex, Near Kali Dungri, Girnar Area, Kishangarh, Rajasthan - 305801, India',
};

const ShivayInfo = () => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const handleImageClick = (image: string) => {
    setSelectedImage(image);
  };

  const handleCloseDialog = () => {
    setSelectedImage(null);
  };

  return (
    <Box id="shivay-info-section" sx={{ pt: 0, pb: 3, backgroundColor: 'background.default' }}>
      <Container maxWidth="lg">
        {/* <LogoContainer>
          <img src="/images/shivay/logo/shivay-logo.png" alt="Shivay Stonex Logo" />
        </LogoContainer>
         */}
        <Typography variant="h4" component="h2" gutterBottom align="center" sx={{ mb: 1 }}>
          About Shivay Stonex
        </Typography>
        <Typography variant="subtitle1" gutterBottom align="center" color="textSecondary" sx={{ mb: 6 }}>
          Your trusted partner in premium marble, granite, and epoxy solutions
        </Typography>
        
        <Grid container spacing={4} sx={{ mb: 6 }}>
          <Grid item xs={12} md={6}>
            <Typography variant="body1" paragraph>
              Shivay Stonex is a leading supplier of premium quality marble from Kishangarh, Rajasthan. 
              With over 15 years of experience in the marble industry, we have established ourselves as 
              a trusted name in providing high-quality Italian, Spanish, Indian, and Turkish marbles.
            </Typography>
            <Typography variant="body1" paragraph>
              Our commitment to quality, customer satisfaction, and ethical business practices has made 
              us a preferred choice for architects, interior designers, and homeowners across India and abroad.
            </Typography>
            <Typography variant="body1">
              We source our marbles directly from the finest quarries around the world and ensure that 
              each piece meets our exacting standards of quality and aesthetics.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <StyledPaper elevation={3}>
              <Typography variant="h5" gutterBottom>
                Contact Information
              </Typography>
              <ContactInfo>
                <LocationOnIcon />
                <Typography>
                  {contactInfo.address}
                </Typography>
              </ContactInfo>
              <ContactInfo>
                <PhoneIcon />
                <Typography>
                  {contactInfo.phone}
                </Typography>
              </ContactInfo>
              <ContactInfo>
                <EmailIcon />
                <Typography>
                  {contactInfo.email}
                </Typography>
              </ContactInfo>
              <ContactInfo>
                <AccessTimeIcon />
                <Typography>
                  Mon - Sun: 9:00 AM - 6:00 PM
                </Typography>
              </ContactInfo>
              <Button variant="contained" color="primary" sx={{ mt: 2 }} href="https://www.google.com/maps/place/SHIVAY+STONEX/data=!4m2!3m1!1s0x0:0x60643c52baf04a7e?sa=X&ved=1t:2428&ictx=111" target="_blank" rel="noopener noreferrer">
                Get Directions
              </Button>
            </StyledPaper>
          </Grid>
        </Grid>
        
        {/* <Typography variant="h4" component="h2" gutterBottom align="center" sx={{ mb: 1 }}>
          Our Gallery
        </Typography>
        <Typography variant="subtitle1" gutterBottom align="center" color="textSecondary" sx={{ mb: 6 }}>
          Explore our stunning marble collection
        </Typography> */}
        
        {/* <Grid container spacing={3}>
          {galleryImages.map((image, index) => (
            <Grid item key={index} xs={12} sm={6} md={4}>
              <GalleryCard onClick={() => handleImageClick(image)}>
                <CardMedia
                  component="img"
                  height="200"
                  image={image}
                  alt={`Gallery Image ${index + 1}`}
                />
              </GalleryCard>
            </Grid>
          ))}
        </Grid> */}
        
        <Dialog
          open={!!selectedImage}
          onClose={handleCloseDialog}
          maxWidth="md"
          fullWidth
        >
          <DialogContent sx={{ p: 0, position: 'relative' }}>
            <IconButton
              aria-label="close"
              onClick={handleCloseDialog}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: 'white',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.7)',
                },
              }}
            >
              <CloseIcon />
            </IconButton>
            {selectedImage && (
              <img 
                src={selectedImage} 
                alt="Gallery" 
                style={{ width: '100%', height: 'auto' }} 
              />
            )}
          </DialogContent>
        </Dialog>
        
        <Box sx={{ mt: 6, textAlign: 'center' }}>
          <Typography variant="h5" component="h3" gutterBottom>
            Visit Our Showroom
          </Typography>
          <Typography variant="body1" color="textSecondary" paragraph>
            {contactInfo.address}
          </Typography>
          <Button 
            variant="contained" 
            color="primary" 
            startIcon={<LocationOnIcon />}
            href="https://www.google.com/maps/place/SHIVAY+STONEX/data=!4m2!3m1!1s0x0:0x60643c52baf04a7e?sa=X&ved=1t:2428&ictx=111"
            target="_blank"
            rel="noopener noreferrer"
          >
            Get Directions
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default ShivayInfo; 